export default {"src":"/_next/static/media/exclamation-triangle.b1568864.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};